"use strict";
// packages/types/src/organisationProfile.ts
Object.defineProperty(exports, "__esModule", { value: true });
